<template>
  <div>
    <el-dialog :visible.sync="dialogFormVisible" title="用户详情" width="80%">
      <el-descriptions :column="4" size="small" border>
        <el-descriptions-item label="姓名">{{ userForm.name }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ userForm.account }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ userForm.sex==1?'男':userForm.sex==2?'女':'' }}</el-descriptions-item>
        <el-descriptions-item label="身份证号码">{{ userForm.id_card }}</el-descriptions-item>
        <el-descriptions-item label="部门">{{ deptObj[userForm.department_id] }}</el-descriptions-item>
        <el-descriptions-item label="出生年月">{{ userForm.birth_day }}</el-descriptions-item>
        <el-descriptions-item label="入职时间">{{ userForm.join_time }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ userForm.email }}</el-descriptions-item>
        <el-descriptions-item label="居住地址">{{ userForm.Residential_address }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ userForm.area_id }}</el-descriptions-item>
        <el-descriptions-item label="是否部门领导">{{ userForm.is_lead=='1'?'是':'否' }}</el-descriptions-item>
        <el-descriptions-item label="是否启用">{{ userForm.is_enable=='1'?'是':'否' }}</el-descriptions-item>
        <el-descriptions-item label="是否离职">{{ userForm.is_quit=='1'?'是':'否' }}</el-descriptions-item>
        <el-descriptions-item label="部门备注">{{ userForm.note }}</el-descriptions-item>
        <!-- <el-descriptions-item :span="2" label="备注">{{ rowData.executor_name }}</el-descriptions-item>
        <el-descriptions-item label="附件">{{ rowData.executor_name }}</el-descriptions-item> -->
      </el-descriptions>
      
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelDialog()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import uploadImg from '@/components/uploadImg'
import { erpDataApi } from "@/utils/request";

export default {
  name: 'userDetail',
  props: {
    value: {
      type: Boolean,
      default: false
    },

  },
  components: {
    // uploadImg
  },
  data() {
    return {
      dialogFormVisible: false,
      deptObj: {},
      userForm: {"id":"6495cbea-0c2e-4fbc-a1d0-2dec090a923d","name":"张张","account":"15656569696","email":"","join_time":"2024-03-05","id_card":"","user_logo":"","sex":"1","birth_day":"1970-01-01","Residential_address":"","is_party_member":"","is_enable":"1","department_id":"2a6040f2-9d14-4d7d-8bac-e224003db5fb","is_lead":"2","is_quit":"0","area_id":"","villages_id":"0b89d95d-e551-46b6-b672-41acdde5704a"},
      tableData: [],
    }
  },
  watch: {
    value(n, o) {
      this.dialogFormVisible = n;
    },
    dialogFormVisible(n, o) {
      if (!n) {
        this.$emit('input', false)
      }
    }
  },
  async created() {
    var resp = await erpDataApi.getDepartment();
    resp.Rows[0].id = resp.Rows[0].villages_id;
    this.deptObj[resp.Rows[0].villages_id]= resp.Rows[0].text;
    this.getdeptList(resp.Rows[0]);
  },
  mounted() {
  },
  methods: {
    getdeptList(data) {
      (data.nodes || []).forEach(item=> {
        this.deptObj[item.id]= item.text;
        if(item.nodes && item.nodes.length>0){
          this.getdeptList(item)
        }
      })
    },
    cancelDialog() {
      this.dialogFormVisible = false;
    }
  },
}

</script>
<style scoped lang="scss">
.spanClass {
  border-left: 5px solid #063cf4;
  padding-left: 8px;
  margin-bottom: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/BaseSettings/component/orgStructureSettings/userDetail.vue